import { FC } from 'react';
import { Player } from '../utils/Player';

import '../Styles/Overlay.css';
import { getRank } from '../utils/Ranks';

type OverlayDisplayProps = {
    user: Player;
    showDisplayName: boolean;
    showConnectCode: boolean;
    showRankIcon: boolean;
    showRankName: boolean;
    showRankNumber: boolean;
    backgroundColor: string;
    showWinLoss: boolean;
};

const OverlayDisplay: FC<OverlayDisplayProps> = (props: OverlayDisplayProps) => {
    const playerRank = getRank(props.user);
    const connectParts = props.user.connectCode.code.split('#');

    return (
        <div className='overlay' style={ { backgroundColor: props.backgroundColor } }>
            { props.showDisplayName && <p className='displayName'>{ props.user.displayName }</p> }
            { props.showConnectCode && <p className='connectCode'>
                <span className='connectCodeName'>{ connectParts[ 0 ] }</span>
                <span className='connectCodeNum'>#{ connectParts[ 1 ] }</span>
            </p> }
            { props.showRankIcon && <img src={ playerRank.iconUrl } className='rankIcon' alt='Rank Icon' /> }
            { props.showRankName && <p className='rankName'>{ playerRank.name }</p> }
            { props.showRankNumber && <p className='mmr'>{ props.user.rankedNetplayProfile.ratingOrdinal.toFixed(2) } rating</p> }
            { props.showWinLoss && <div>
                <p className='winLoss'>Wins / Losses</p>
                <div className='winLossContainer'>
                    <p className='marginZero' style={ { color: 'rgb(46, 204, 64)' } }>{ props.user.rankedNetplayProfile.wins }</p>
                    <p className='marginZero' style={ { color: 'rgb(94, 96, 102)' } }>/</p>
                    <p className='marginZero' style={ { color: 'rgb(255, 77, 0)' } }>{ props.user.rankedNetplayProfile.losses }</p>
                </div>
            </div> }
        </div>
    );
};

export default OverlayDisplay;